import { Controller } from "@hotwired/stimulus";

export default class UIToggleGroupController extends Controller {
  static targets = ["item"];
  static values = { multiple: Boolean };

  connect() {
    this.initializeFromValue();
  }

  initializeFromValue() {
    const initialValue = this.element.dataset.value;
    if (!initialValue) return;

    const values =
      this.multipleValue && Array.isArray(initialValue) ? initialValue : [initialValue];

    this.itemTargets.forEach((item) => {
      const itemValue = item.dataset.value;
      if (values.includes(itemValue)) {
        this.selectItem(item);
      } else {
        this.deselectItem(item);
      }
    });
  }

  toggle(event) {
    const button = event.currentTarget;
    const isOn = button.dataset.state === "on";

    if (this.multipleValue) {
      if (isOn) {
        this.deselectItem(button);
      } else {
        this.selectItem(button);
      }
    } else {
      if (isOn) {
        this.deselectItem(button);
      } else {
        this.itemTargets.forEach((item) => {
          if (item !== button) {
            this.deselectItem(item);
          }
        });
        this.selectItem(button);
      }
    }

    this.dispatch("change", {
      detail: {
        value: this.getValue(),
        multiple: this.multipleValue,
      },
    });
  }

  selectItem(button) {
    button.dataset.state = "on";
  }

  deselectItem(button) {
    button.dataset.state = "off";
  }

  getValue() {
    const selectedButtons = this.itemTargets.filter((button) => button.dataset.state === "on");
    const values = selectedButtons.map((button) => button.dataset.value);

    if (this.multipleValue) {
      return values;
    } else {
      return values[0] || null;
    }
  }
}
